export default {
  empty: '暂无已选产品',
};
